import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { SimilarParagraphsEffects } from './similar-paragraph.effects';
import { reducer } from './similar-paragraph.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('similarParagraph', reducer),
    EffectsModule.forFeature([SimilarParagraphsEffects]),
  ],
  providers: [SimilarParagraphsEffects],
})
export class SimilarParagraphStoreModule {}
